import React from 'react';
import { computeRemSize } from '@ydistri/theme';
import { CalculationStatisticStoreTargetResponse } from '@ydistri/api-sdk';
import { useTableTargetStoreColumns } from '../columns/useTableTargetStoreColumns';
import { DataTable } from '@ydistri/ds';

interface PrefilledTableTargetStoreProps {
  data: CalculationStatisticStoreTargetResponse[] | undefined;
  displayDepartment?: boolean;
}

const PrefilledTableTargetStore: React.FC<PrefilledTableTargetStoreProps> = ({
  data,
  displayDepartment = false,
}) => {
  const columns = useTableTargetStoreColumns(displayDepartment);

  return (
    <DataTable<CalculationStatisticStoreTargetResponse>
      id="predefined-statistics-target-store-table"
      columns={columns}
      dataSource={data}
      size="small"
      height={computeRemSize(400)}
      showHeader
      showBorder
    />
  );
};

export default PrefilledTableTargetStore;
